import React from "react";
import { useLocation } from "react-router-dom";

const PlayersBoard = ({ winnerScore , winFirst, winSecond }) => {
    const { state } = useLocation();

  if (winnerScore[0]?.count > winnerScore[1]?.count) {
    alert("Congratulation you are the top scorerer");
  }

  return (
    <div>
      <h3> Score Board </h3>
         <h4 style ={{color :"blue"}}> {state.firstname} Wins : {winFirst}  </h4>
         <h4 style ={{color :"red"}}> {state.secondname} wins : {winSecond}</h4>
         <h5> ---------------------------</h5>

      {winnerScore
        .sort((a, b) => a.count - b.count)
        .slice(0, 5)
        .map((win) => {
          return (
            <>
              <h5>
                Winner: {win.name} & Count: {win.count}
              </h5>
            </>
          );
        })}
         <br />  <br /> <br /> <br /> <br /> <br />

      
    </div>
  );
};

export default PlayersBoard;
